/**
 * What a repayment schedule adds up to, for the summary above the table.
 * Rows are the calculator's rows (payment, interest, principal, starting_balance, ending_balance).
 */
import { formatNaira } from "../../utils/dashboardFormat";

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const pay = (row) => num(row?.payment ?? row?.amount);
const cents = (n) => Math.round(n * 100) / 100;

export function summarizeSchedule(rows) {
  const list = Array.isArray(rows) ? rows.filter(Boolean) : [];
  if (!list.length) return null;

  const totalInterest = cents(list.reduce((s, r) => s + num(r.interest), 0));
  const totalPayable = cents(list.reduce((s, r) => s + pay(r), 0));
  const principal = cents(list.reduce((s, r) => s + num(r.principal), 0));
  const first = pay(list[0]);
  const last = pay(list[list.length - 1]);

  return { periods: list.length, principal, totalInterest, totalPayable, first, last, falling: last < first - 0.005 };
}

/** The tiles shown above the schedule. */
export function summaryFacts(summary) {
  if (!summary) return [];
  const facts = [
    { key: "interest", label: "Total interest", value: formatNaira(summary.totalInterest) },
    { key: "total", label: "Total to repay", value: formatNaira(summary.totalPayable) },
  ];
  if (summary.periods > 1 && Math.abs(summary.first - summary.last) > 0.05) {
    facts.push(
      { key: "first", label: "First payment", value: formatNaira(summary.first) },
      { key: "last", label: "Last payment", value: formatNaira(summary.last) }
    );
  } else {
    facts.push({ key: "each", label: summary.periods > 1 ? "Each payment" : "Payment", value: formatNaira(summary.first) });
  }
  return facts;
}
